import axios from "axios";

export const downloadFile = (url: string, docName: string) => url && docName ?
  axios({
    url: url,
    method: 'GET',
    responseType: 'blob',
  })
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.rel = 'noreferrer nofollow';
      link.setAttribute('download', docName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    }) : undefined;
